import styled from 'styled-components';
import { getStyle as getMenu } from '@ids/ddms-styled/comps/dropMenu/intuit/light';
import { getStyle as getDropdown } from '@ids/ddms-styled/comps/dropdown/intuit/light';
import hexToRgba from 'hex-rgba';
import TextField from '@ids/text-field';
import { Menu, MenuItem } from '@ids/menu';
import { ChevronDownIcon, AddIcon } from '@ids/internal-icons';

// TODO: design data for inner icon size
const iconSizeXs = '16px';
const inputIconColor = getDropdown('icon.color.default');
const inputRadius = getDropdown('field.radius');
const inputOpacity = getDropdown('input.opacity');
const addFontWeight = getMenu('addItemText.fontWeight');
const itemHoverColor = getMenu('lineItem.color.hover');
const blue02 = '#0077C5';
const green01 = '#108000';
const gray01 = '#393A3D';
const gray04 = '#BABEC5';
const gray05 = '#D4D7DC';
const gray07 = '#ECEEF1';
const red02 = '#D52B1E';
const orange02 = '#FF6A00';
const themes = {
  // TODO: design data for themes of icon
  intuit: {
    chevronColor: blue02 // productColor
  },
  mint: {
    chevronColor: '#15EFE9' // teal05
  },
  proconnect: {
    chevronColor: blue02 // productColor
  },
  quickbooks: {
    chevronColor: '#2CA01C' // green02
  },
  turbotax: {
    chevronColor: '#06b6c9' // cgTeal04
  }
};

export const Wrapper = styled.div`
  width: ${props => (props.width ? props.width : 'fit-content')};
  outline: none;
`;

export const AddNewIcon = styled(AddIcon)`
  position: relative;
  width: 20px;
  height: 20px;
  top: 4px;
  fill: ${({ theme }) => (theme === 'quickbooks' ? green01 : blue02)};
  font-weight: ${addFontWeight};
`;

export const AddNewTextContainer = styled.span`
  font-weight: ${getMenu('lineItem.fontWeight')};
  padding: 0 8px;
  width: 16px;
  height: 16px;
`;
export const AddNewValueContainer = styled.span`
  font-weight: ${addFontWeight};
`;

export const AddNewItem = styled(MenuItem)`
  font-style: ${getMenu('lineItem.fontStyle')};
  font-size: ${getMenu('lineItem.fontSize')};
  line-height: ${getMenu('lineItem.lineHeight')};
  color: ${({ theme }) => (theme === 'quickbooks' ? gray01 : blue02)};
  ${props =>
    !props.highlighted &&
    `
    background-color: ${gray05}
  `}
  &:hover * {
    color: ${itemHoverColor};
  }
  &:hover ${AddNewIcon} {
    fill: ${itemHoverColor};
  }
`;

export const MenuWrapper = styled(Menu)`
  margin-top: 4px;
  margin-bottom: 4px;
  max-height: 300px;
  ${props => `
    min-width: ${props.parentWidth || 200}px;
  `}
  ${props =>
    !props.withItems &&
    `
    display: none;
  `}
  div[aria-selected="true"] ${AddNewIcon} {
    fill: ${itemHoverColor};
  }
`;

export const IconBox = styled.div`
  outline: none;
  margin: 0 !important;
  right: 1px !important;
  top: 1px;
  padding: 10px 8px 8px 9px;
  height: 34px;
  border-left: 1px solid ${gray04};
  border-radius: 0 ${inputRadius} ${inputRadius} 0;
  box-sizing: border-box;
  cursor: pointer;
  ${props =>
    !props.disabled &&
    !props.infoType &&
    `
    &:hover {
      background-color: ${gray07} !important;
    }
  `}
  ${props =>
    props.disabled &&
    `
    cursor: not-allowed;
    opacity: ${getDropdown('field.borderOpacity.disabled') / 100};
  `}
  ${props =>
    props.infoType === 'error' &&
    `
    border-color: ${hexToRgba(red02, inputOpacity)};
  `}
  ${props =>
    props.infoType === 'warning' &&
    `
    border-color: ${hexToRgba(orange02, inputOpacity)};
  `}
`;

export const DownIconWrapper = styled(ChevronDownIcon)`
  height: ${iconSizeXs} !important;
  width: ${iconSizeXs} !important;
  fill: ${inputIconColor};
  ${props =>
    props.disabled &&
    `
    fill: ${hexToRgba(inputIconColor, getMenu('lineItem.opacity.disabled'))};
  `}
  ${props =>
    props.infoType === 'error' &&
    `
    fill: ${getDropdown('icon.color.error')} !important;
  `}
  ${props =>
    props.infoType === 'warning' &&
    `
    fill: ${getDropdown('icon.color.warning')} !important;
  `}
`;

export const TextFieldWrapper = styled(TextField)`
  ${props =>
    !props.disabled &&
    `
    input {
      cursor: pointer;
      &::-ms-clear {
        display: none;
      }
      ${
        !props.errorText && !props.warningText && themes[props.theme]
          ? `
        &:focus + ${IconBox} > ${DownIconWrapper} {
          fill: ${themes[props.theme].chevronColor};
        }
        &:hover + ${IconBox} {
          background-color: ${gray07} !important; 
        }`
          : null
      }
  `}
`;
